import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c347dcc6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c347dcc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c347dcc6')) {
      api.createRecord('c347dcc6', component.options)
    } else {
      api.reload('c347dcc6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c347dcc6&scoped=true&", function () {
      api.rerender('c347dcc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/divisionManage/versionManage/index.vue"
export default component.exports